'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  'btn:save': '保存',
  'btn:cancel': '取消',
  'btn:clear': '清除'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/lib/color-picker/locale/zh_CN.js
// module id = LfH9
// module chunks = 3